import Head from "next/head";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { getNitoelEnv } from "components/EnvInfo";

type Props = {
  title?: string;
  primaryLang?: string;
};

const PageHead: React.FC<Props> = ({ title, primaryLang }) => {
  const { t, ready } = useTranslation("common");
  const [envPrefix, setEnvPrefix] = useState("");

  useEffect(() => {
    try {
      const env = getNitoelEnv();
      if (env !== "prod" && env !== "unknown") {
        setEnvPrefix(`[${env}] `);
      }
    } catch (e) {
      console.warn("Failed to detect environment in PageHead:", e);
    }
  }, []);

  const fallbackTitle = primaryLang === "ja" ? "ニトエル" : "nitoel";
  const serviceName = ready ? t("service_name") : fallbackTitle;

  return (
    <Head>
      {/* [環境名] 機能タイトル | ニトエル */}
      <title>{`${envPrefix}${title ? `${title} | ` : ""}${serviceName}`}</title>
    </Head>
  );
};

export default PageHead;
